export const getToggleLabel = (label) => {
  return typeof label === 'string' ? label.trim() : label;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Toggle/utils/toggleHelpers.js